import * as queryString from 'query-string'
import { handleError } from '../utils/commonUtils'
import ApisLogService from './indexAuditLog'
// Get list of audit logs with filter and pagination
export function getListAuditLogs(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisLogService.get('/audit-logs', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Get change history of a specific entity
export function getAuditLogsByEntity(entityType: string, entityId: string) {
  try {
    return ApisLogService.get(`/audit-logs/entity/${entityType}/${entityId}`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Get audit log statistics (by action, user, entity, timeline)
export function getAuditLogsStats(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisLogService.get('/audit-logs/stats', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}